import React, { useState, useEffect } from 'react';
import { Toast, ToastContainer } from "react-bootstrap";
import { eventDispatcher } from '../../eventDispatcher.js';
import { hubEventTypes, customEventTypes } from "../../constants.js";
import NotificationItem from '../menu/NotificationItem.js';

const NotificationMessanger = () => {
    const [notifications, setNotifications] = useState([]);
    const [shownIds, setShownIds] = useState([]);

    useEffect(() => {
        const onNotificationAddedId = eventDispatcher.subscrubeToEvent(hubEventTypes.notificationAdded, (notification) => {
            addNotification(notification);
        });
        const onShowMessageId = eventDispatcher.subscrubeToEvent(customEventTypes.onShowMessage, (notification) => {
            addNotification(notification);
        });

        return () => {
            eventDispatcher.unsubscrubeFromEvent(onNotificationAddedId);
            eventDispatcher.unsubscrubeFromEvent(onShowMessageId);
        }
    }, []);

    const addNotification = (notification) => {
        if (!shownIds.some(id => id === notification.id)) {
            setShownIds((prevShownIds) => [...prevShownIds, notification.id]);
            setNotifications((prevNotifications) => [...prevNotifications, notification]);
            setTimeout(() => onClose(notification.id), 4000);
        }
    }

    const onClose = (id) => {
        setNotifications((prevNotifications => prevNotifications.filter(n => n.id !== id)));
    }

    if (notifications.length === 0) {
        return <></>
    }
    else {
        return <div className='notification-messanger'>
            <ToastContainer>
                {notifications.map(n => <Toast key={n.id}>
                    <Toast.Body>
                        <NotificationItem notification={n} />
                    </Toast.Body>
                </Toast>)
                }
            </ToastContainer>
        </div>
    }
}

export default NotificationMessanger;